import { render, staticRenderFns } from "./Printprocedures.vue?vue&type=template&id=6689c0e9"
import script from "./Printprocedures.vue?vue&type=script&lang=js"
export * from "./Printprocedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports